import {
    closeAttachmentFolderPicker,
    openAttachmentFolderPicker,
} from '../actions/internalActions';
import { getStore } from '../store/store';
import { mutator } from 'satcheljs';

mutator(openAttachmentFolderPicker, () => {
    getStore().isOpen = true;
});

mutator(closeAttachmentFolderPicker, () => {
    getStore().isOpen = false;
});
